import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHookSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-163">
      <div className="max-w-3xl mx-auto" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg md:prose-xl text-foreground/80 max-w-none" data-id="element-165">
          <p className="lead text-xl md:text-2xl font-medium text-foreground mb-6" data-id="element-166">
            School starts in a few weeks... and then the email hits:
          </p>

          <blockquote className="border-l-4 border-secondary pl-6 py-2 my-8 bg-secondary/5 rounded-r-lg italic text-secondary font-serif text-xl md:text-2xl" data-id="element-167">
            "Your child must be fully potty trained to attend."
          </blockquote>

          <p className="mb-6" data-id="element-168">
            Instant panic. Because you've tried everything—sticker charts,
            treats, sitting them on the potty every 10 minutes—and it's still
            not clicking.
          </p>

          <p className="mb-6" data-id="element-169">
            Meanwhile diapers keep getting more expensive, and you're quietly
            wondering if you're the only parent whose kid still needs a Pull-Up.
          </p>

          <div className="mt-10 p-6 md:p-8 bg-accent rounded-2xl border border-border" data-id="element-170">
            <p className="text-xl md:text-2xl font-serif font-semibold text-foreground m-0 text-center text-balance leading-snug" data-id="element-171">
              You're not failing. You've just been using a method that was never
              built for real-life deadlines.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}